import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from './app'
import auth from './auth'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import ws from './socket'

import DashBoardStore   from '../app/dashboard/state/dashboard-store.js'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    app,
    appConfig,
    verticalMenu,
    ws
   // DashBoardStore,
    // 'app-ecommerce': ecommerceStoreModule,
  },
  strict: process.env.DEV,
})
